export default __webpack_public_path__ + "static/media/logomark.634ce039.png";